import { useTranslation } from 'react-i18next';

import { Headline } from 'components/Headline';
import { Loader } from 'components/Loader';

import { useList } from './List.hooks';
import * as S from './List.styles';

export function List(): React.ReactElement {
  const { notificationsItems, isLoading } = useList();
  const { t } = useTranslation();
  return (
    <Loader isLoading={isLoading}>
      {notificationsItems && notificationsItems.length > 0 ? (
        notificationsItems
      ) : (
        <S.Container>
          <Headline scale="xl2">{t('notification.noNotifications')}</Headline>
        </S.Container>
      )}
    </Loader>
  );
}
